const CheckboxHideShow = {

    init() {
        let self = this;
        
        if(document.querySelectorAll('.js-checkbox-hide-show').length > 0) {
            self._create();
        }
    },

    _create() {
        document.querySelectorAll('.js-checkbox-hide-show:not(data-initialized)').forEach(componentNode => {
            componentNode.dataset.initialized = '1';

            let inputNodes = componentNode.querySelectorAll('input[data-hideshowcheckbox]');
            inputNodes.forEach(inputNode => {
                inputNode.addEventListener('change', () => {
                    let activeType = inputNode.dataset.hideshowcheckbox;

                    // control content state
                    componentNode.querySelectorAll('div[data-hideshowcontent]').forEach(contentNode => {
                        console.log('4968456');
                        if (activeType === contentNode.dataset.hideshowcontent) {
                            if(inputNode.checked == true){
                                contentNode.classList.add('hide-show-active');
                                return
                            }
                            contentNode.classList.remove('hide-show-active');
                            

                            return;
                        }

                        //contentNode.classList.remove('hide-show-active');
                    });
                });
            });
        });
    },
}

CheckboxHideShow.init();

document.addEventListener('LokiRequestEnd', function () {
    CheckboxHideShow.init();
});
